import { render, staticRenderFns } from "./BookingFormV3.vue?vue&type=template&id=e2455f6a"
import script from "./BookingFormV3.vue?vue&type=script&lang=js"
export * from "./BookingFormV3.vue?vue&type=script&lang=js"
import style0 from "./BookingFormV3.vue?vue&type=style&index=0&id=e2455f6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports